/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Leg
 */
export interface Leg {
    /**
     * Unique identifier for the leg
     * @type {string}
     * @memberof Leg
     */
    readonly id: string;
    /**
     * Travel mode for this leg
     * @type {string}
     * @memberof Leg
     */
    travelMode: LegTravelModeEnum;
    /**
     * Estimated travel time in minutes
     * @type {number}
     * @memberof Leg
     */
    travelTimeMinutes?: number;
    /**
     * Distance in meters
     * @type {number}
     * @memberof Leg
     */
    distanceMeters?: number;
    /**
     * Route geometry as GeoJSON from Mapbox
     * @type {object}
     * @memberof Leg
     */
    route?: object;
    /**
     * Additional notes for this leg of the journey
     * @type {string}
     * @memberof Leg
     */
    notes?: string;
    /**
     * Timestamp when the leg was created
     * @type {Date}
     * @memberof Leg
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the leg was last updated
     * @type {Date}
     * @memberof Leg
     */
    readonly updatedAt: Date;
    /**
     * ID of the starting stop
     * @type {string}
     * @memberof Leg
     */
    readonly fromStopId: string;
    /**
     * ID of the ending stop
     * @type {string}
     * @memberof Leg
     */
    readonly toStopId: string;
    /**
     * ID of the parent itinerary
     * @type {string}
     * @memberof Leg
     */
    readonly itineraryId: string;
    /**
     * Starting coordinates of the leg (from fromStop)
     * @type {Array<string>}
     * @memberof Leg
     */
    readonly fromCoordinates: Array<string>;
    /**
     * Ending coordinates of the leg (from toStop)
     * @type {Array<string>}
     * @memberof Leg
     */
    readonly toCoordinates: Array<string>;
}


/**
 * @export
 */
export const LegTravelModeEnum = {
    Walking: 'WALKING',
    Driving: 'DRIVING',
    Cycling: 'CYCLING'
} as const;
export type LegTravelModeEnum = typeof LegTravelModeEnum[keyof typeof LegTravelModeEnum];


/**
 * Check if a given object implements the Leg interface.
 */
export function instanceOfLeg(value: object): value is Leg {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('travelMode' in value) || value['travelMode'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('fromStopId' in value) || value['fromStopId'] === undefined) return false;
    if (!('toStopId' in value) || value['toStopId'] === undefined) return false;
    if (!('itineraryId' in value) || value['itineraryId'] === undefined) return false;
    if (!('fromCoordinates' in value) || value['fromCoordinates'] === undefined) return false;
    if (!('toCoordinates' in value) || value['toCoordinates'] === undefined) return false;
    return true;
}

export function LegFromJSON(json: any): Leg {
    return LegFromJSONTyped(json, false);
}

export function LegFromJSONTyped(json: any, ignoreDiscriminator: boolean): Leg {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'travelMode': json['travelMode'],
        'travelTimeMinutes': json['travelTimeMinutes'] == null ? undefined : json['travelTimeMinutes'],
        'distanceMeters': json['distanceMeters'] == null ? undefined : json['distanceMeters'],
        'route': json['route'] == null ? undefined : json['route'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'fromStopId': json['fromStopId'],
        'toStopId': json['toStopId'],
        'itineraryId': json['itineraryId'],
        'fromCoordinates': json['fromCoordinates'],
        'toCoordinates': json['toCoordinates'],
    };
}

  export function LegToJSON(json: any): Leg {
      return LegToJSONTyped(json, false);
  }

  export function LegToJSONTyped(value?: Omit<Leg, 'id'|'createdAt'|'updatedAt'|'fromStopId'|'toStopId'|'itineraryId'|'fromCoordinates'|'toCoordinates'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'travelMode': value['travelMode'],
        'travelTimeMinutes': value['travelTimeMinutes'],
        'distanceMeters': value['distanceMeters'],
        'route': value['route'],
        'notes': value['notes'],
    };
}

